import { clickOutside } from "@/assets/js/directives/clickOutside";

export const globalDirectives = {
  install(Vue) {
    Vue.directive("click-outside", clickOutside);
  },
};
